module.exports = __webpack_public_path__ + "static/media/emperor.04349689.png";